define("Mad_Utils/js/mixins/lib/jquery/migrate-mute",[],(function(){"use strict";return function(e){return e.migrateTrace=!1,e}}));
